export const RECORD_ANSWER = 'RECORD_ANSWER';

// TODO: Update when we want to persist this info somewhere
export function recordAnswer({ key, value }) {
  return {
    type: RECORD_ANSWER,
    key,
    value,
  };
}
